import { Link, useNavigate } from "react-router-dom";
import UserAvatarBaseIcon from "./../../assets/images/blank-avatar.png";
// import AvatarIcon from "./../../assets/icons/avatar.svg?react";
import UserIcon from "./../../assets/icons/user.svg?react";
import TeamsIcon from "./../../assets/icons/teams.svg?react";
import SignOutIcon from "./../../assets/icons/sign-out.svg?react";
import AdminIcon from "./../../assets/icons/computer-desktop.svg?react";
import {
  SettingsBillingUrl,
  SettingsProfileUrl,
  SettingsTeamsUrl,
  // SignInUrl,
} from "../../utils/urls";
import {
  logout,
  selectLogin,
  selectOnStageEnv,
  selectUser,
} from "../../store/auth/authSlice";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { BASE_URL } from "../../apis";
import {
  Alert,
  Dropdown,
  DropdownElement,
  Flex,
  Typography,
} from "djuno-design";
import { ShineBorder } from "../general/ShineBorder";
import { useMemo } from "react";
import { encodeJWTForUrl } from "../../utils";

const UserDropdown: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const login = useAppSelector(selectLogin);
  const user = useAppSelector(selectUser);
  const onStageEnv = useAppSelector(selectOnStageEnv);
  const dispatch = useAppDispatch();

  const userDropdoemItems: Array<DropdownElement> = useMemo(() => {
    const profileItem: DropdownElement = {
      key: "profile",
      label: (
        <div className="flex items-center gap-2">
          <UserIcon className="w-4 h-4" /> Profile
        </div>
      ),
      onClick: (_, close) => {
        close();
        navigate(SettingsProfileUrl);
      },
    };

    const teamItem: DropdownElement = {
      key: "team",
      label: (
        <div className="flex items-center gap-2">
          <TeamsIcon className="w-4 h-4" /> Teams
        </div>
      ),
      onClick: (_, close) => {
        close();
        navigate(SettingsTeamsUrl);
      },
      disabled: !onStageEnv?.IsAccountOwner,
    };

    const adminPanelItem: DropdownElement = {
      key: "admin-panel",
      label: (
        <div className="flex items-center gap-2 w-full h-full">
          <AdminIcon className="w-4 h-4" />
          Admin Panel
        </div>
      ),
      onClick: () => {
        if (login?.JwtToken)
          window.location.href = `${
            import.meta.env.VITE_ADMIN_URL
          }auth/signin?token=${encodeJWTForUrl(login.JwtToken)}`;
      },
    };

    const localAdminPanelItem: DropdownElement = {
      key: "local-admin-panel",
      label: (
        <div className="flex items-center gap-2 w-full h-full">
          <AdminIcon className="w-4 h-4" />
          Local Admin Panel
        </div>
      ),
      onClick: () => {
        if (login?.JwtToken)
          window.location.href = `http://localhost:8080/auth/signin?token=${encodeJWTForUrl(
            login.JwtToken
          )}`;
      },
    };

    const signoutItem: DropdownElement = {
      key: "signout",
      label: (
        <div className="flex items-center gap-2">
          <SignOutIcon className="w-4 h-4" /> Sign out
        </div>
      ),
      danger: true,
      onClick: () => {
        dispatch(logout());
        navigate("/");
      },
    };
    const items = [
      profileItem,
      teamItem,
      user?.AdminAccess ? adminPanelItem : undefined,
      import.meta.env.VITE_APP_SCOPE === "dev" && user?.AdminAccess === true
        ? localAdminPanelItem
        : undefined,
      { type: "divider" } as DropdownElement,
      signoutItem,
    ].filter(Boolean) as DropdownElement[];

    return items;
  }, [
    dispatch,
    login?.JwtToken,
    navigate,
    onStageEnv?.IsAccountOwner,
    user?.AdminAccess,
  ]);

  return (
    <Dropdown
      title={
        <Flex direction="col">
          <Typography.Text size="xs" className="truncate overflow-hidden">
            {user?.FullName}
          </Typography.Text>
          <Typography.Text
            size="xs"
            uiType="transparent"
            className="truncate overflow-hidden"
          >
            {user?.Email}
          </Typography.Text>
          {onStageEnv &&
            onStageEnv.EnvironmentStatus === 4 &&
            onStageEnv.IsAccountOwner &&
            !onStageEnv.HaveCardAttempt && (
              <Alert
                uiType="warning"
                className="!mt-2"
                message={
                  <Typography.Text className="!text-xs !flex-nowrap">
                    To access all features, please{" "}
                    <Link
                      to={SettingsBillingUrl + "#Payment Method"}
                      className="font-medium"
                    >
                      add a payment method
                    </Link>
                    .
                  </Typography.Text>
                }
              />
            )}
        </Flex>
      }
      menu={userDropdoemItems}
      anchor="bottom end"
    >
      <div className="flex items-center gap-2">
        <div className="w-7 h-7 aspect-square rounded-full relative overflow-hidden shadow">
          <ShineBorder shineColor={["#0074E5", "#A07CFE", "#FFBE7B"]} />
          <UserAvatar />
        </div>

        <div className="hidden md:flex whitespace-nowrap max-w-[100px]">
          <Typography.Text size="sm" className="!truncate !overflow-hidden">
            {user?.FullName}
          </Typography.Text>
        </div>
      </div>
    </Dropdown>
  );
};

export const UserAvatar = () => {
  const user = useAppSelector(selectUser);
  return (
    <img
      src={
        user?.AvatarLink !== null
          ? BASE_URL + user?.AvatarLink
          : UserAvatarBaseIcon
      }
      alt={user?.FullName}
      className="w-full h-full"
    />
  );
};
export default UserDropdown;
